import { useMutation } from '@tanstack/react-query'
import { fileUploadService, type FileUploadCategory } from '../services/file-upload'

/**
 * Upload file mutation
 */
export const useFileUpload = () => {
  return useMutation({
    mutationFn: ({ file, category }: { file: File; category?: FileUploadCategory }) =>
      fileUploadService.uploadFile(file, category),
    onError: (error) => {
      console.error('File upload failed:', error)
    }
  })
}

/**
 * Delete file mutation
 */
export const useFileDelete = () => {
  return useMutation({
    mutationFn: (fileUrl: string) => fileUploadService.deleteFile(fileUrl),
    onError: (error) => {
      console.error('File deletion failed:', error)
    }
  })
}
